// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCcp2RvoV-OmWWnQA9ivQOfksaR5XUfVhU",
    authDomain: "isha-app.firebaseapp.com",
    databaseURL: "https://isha-app.firebaseio.com",
    projectId: "isha-app",
    storageBucket: "isha-app.appspot.com",
    messagingSenderId: "75679483709",
    appId: "1:75679483709:web:c890daebd20e77a272a754",
    measurementId: "G-H11R6L5D57"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
